import { getStreamDayRange } from "./playerTime";
import { getStreamDay } from "./streamDay";

export const getStreamSessions = (stream) => {
    const { broadcastSession } = stream || {};
    const sessions = Array.isArray(broadcastSession) ? broadcastSession : [];
    return sessions.filter(({ disabled }) => !disabled);
};

export const getStreamDurationBySessions = (stream, streamDay = null) => {
    if (!stream) return null;
    const now = Math.round(Date.now() / 1000);
    const sessions = getStreamSessions(stream);
    const duration = stream.timeStop - stream.timeStart;
    const durationBySessions = !sessions.length ? duration : sessions.reduce((duration, { timeStart, timeStop }) => {
        const _timeStop = timeStop || now;
        const additional = ![null, getStreamDay(stream.timeStart, timeStart)].includes(streamDay) ? 0 : _timeStop - timeStart;
        return duration + additional
    }, 0);

    return Math.min(durationBySessions, duration)
}

export const getStreamQualities = (stream) => {
    const { quality } = stream || {};
    const qualities = Array.isArray(quality) ? quality : [];
    const filtered = qualities.filter(({ enabled }) => enabled).sort((a, b) => a.order - b.order);
    if (stream?.liveProfile?.originType === 'wowza') {
        return filtered;
    }
    return [...filtered, { number: 0, label: 'Auto' }];
};

export const getStreamLanguages = (stream) => {
    const { language } = stream || {};
    const languages = Array.isArray(language) ? language : [];
    return languages.filter(({ enabled }) => enabled);
};

export const getStreamMeta = (stream) => {
    const sessions = getStreamSessions(stream);
    const sessionsLength = sessions.length;
    const { timeStart, timeStop, status, archiveStatus, liveProfile } = stream || {}

    const isLive = Boolean(sessionsLength && !sessions[sessionsLength - 1].timeStop);
    const isStarted = Boolean(stream && (timeStart <= Date.now() / 1000 || sessionsLength));
    const isStopped = Boolean(stream && (timeStop <= Date.now() / 1000));
    const isWaiting = Boolean(!status || status === 'idle');
    const isRecord = ['done', 'file'].includes(String(archiveStatus).toLowerCase());
    const isFlussonic = liveProfile?.originType === 'flussonic';

    return { isLive, isStarted, isStopped, isWaiting, isRecord, isFlussonic };
};

export const getCurrentEpisodeSessions = ({ stream, episode }) => {
    if (!stream?.broadcastSession || !episode) return [];

    const now = Math.round(Date.now() / 1000);

    return stream.broadcastSession.filter(({ disabled, timeStart, timeStop }) => {
        if (disabled) return false;

        const sessionEnd = timeStop || now;

        return sessionEnd > episode.timeStart && timeStart < episode.timeStop;
    });
};

export const getCurrentDaySessions = (stream, streamDay) => {
    const sessions = getStreamSessions(stream);
    if (!sessions.length) return [];

    const [dayStart, dayEnd] = getStreamDayRange(stream.timeStart, streamDay);

    return sessions.filter((session) => dayStart && dayEnd
        ? session.timeStart < dayEnd && (!session.timeStop || session.timeStop > dayStart)
        : true
    );
};
